module.exports = "404 page not found.\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/pages/404/404.html
// module id = ./src/pages/404/404.html
// module chunks = main